import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownRounded = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	height: "1em",
	viewBox: "0 0 8 10",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M4 1V9M4 9L1 6M4 9L7 6",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}));
const ForwardRef = forwardRef(SvgArrowDownRounded);
export default ForwardRef;
